import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import type { IEventTelemetry, ICustomProperties } from '@microsoft/applicationinsights-web'

export type { IEventTelemetry, ICustomProperties }

type AppInsightsInstance = Pick<
  ApplicationInsights,
  | 'trackPageView'
  | 'trackEvent'
  | 'setAuthenticatedUserContext'
  | 'clearAuthenticatedUserContext'
  | 'flush'
>

const noop = () => undefined

const stub: AppInsightsInstance = {
  trackPageView: noop,
  trackEvent: noop,
  setAuthenticatedUserContext: noop,
  clearAuthenticatedUserContext: noop,
  flush: noop,
}

function createAppInsights(): AppInsightsInstance {
  const connectionString = import.meta.env['VITE_APPINSIGHTS_CONNECTION_STRING']
  if (!connectionString) {
    console.debug('[Analytics] VITE_APPINSIGHTS_CONNECTION_STRING no está configurado — analytics deshabilitado')
    return stub
  }

  const instance = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: false, // handled via router.subscribe()
      disableAjaxTracking: false,
      enableSessionStorageBuffer: true,
    },
  })
  instance.loadAppInsights()
  return instance
}

export const appInsights: AppInsightsInstance = createAppInsights()
